import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1","key":"svg-0"}],["path",{"d":"M8 13l3 -2l2 2l3 -2","key":"svg-1"}]]

const IconBrandMessenger = createReactComponent('outline', 'brand-messenger', 'BrandMessenger', __iconNode);

export default IconBrandMessenger;